import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import SiteRouter from './SiteRouter';
 
ReactDOM.createRoot(document.getElementById('root')).render(<SiteRouter />);

/* reportWebVitals(); */
